import { Notification } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import Empty from '@components/empty'
import { StyleNotificationBody } from '@components/layouts/style'
import Row from '@components/row'
import Typography from '@components/typography'
import useWindowSize from '@hooks/useWindow'
import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import NotificationInfoCard from './components/notificaitionInfoCard'
import { StyleNotificationHeader } from './style'
import { Actions, store } from '@store/index'

const NotificationPage = ({
  userRole = 'user',
  visible,
  setVisible,
}: {
  userRole: 'admin' | 'user'
  visible: boolean
  setVisible: any
}) => {
  const { width } = useWindowSize()
  const isMobile = width < 1024
  const navigate = useNavigate()
  const { items: notifications, totalItems } = useSelector(
    (state: any) => state.notifications,
  )
  const totalUnreadNotification = useSelector(
    (state: any) => state.totalUnreadNotification,
  )
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  })

  const fetchNotifications = async (action: any, params: any) => {
    {
      userRole === 'admin' &&
        (await Notification.allAdminsNotification(action, params).then(
          (res) => {
            console.log('Fetched Notifications:', res)
          },
        ))
    }
    {
      userRole === 'user' &&
        (await Notification.allNotification(action, params)
          .then((res) => {
            console.log('Fetched Notifications:', res)
          })
          .catch(() => {}))
    }
  }

  useEffect(() => {
    if (!notifications?.length && (visible || isMobile)) {
      fetchNotifications('set', params)
    }
  }, [])
  const onPressNotification = (item) => {
    switch (userRole) {
      case 'user':
        if (item?.notificationType === 'Lend') {
          navigate('/books/history', { state: { activeTab: 'Lend' } })
          !!visible && setVisible(false)
        }
        if (item?.notificationType === 'Borrow') {
          navigate('/books/history', { state: { activeTab: 'Borrow' } })
          !!visible && setVisible(false)
        }
        if (item?.notificationType === 'Subscription' && !!isMobile) {
          navigate('/books/account')
          !!visible && setVisible(false)
        }
        break
      case 'admin':
        if (item?.notificationType === 'Orders') {
          navigate('/admin/order-management')
          !!visible && setVisible(false)
        }
        if (item?.notificationType === 'Subscription') {
          navigate(`/admin/user-managements`)
          !!visible && setVisible(false)
        }
        if (item?.notificationType === 'Books') {
          navigate(`/admin/book-managements`)
          !!visible && setVisible(false)
        }
        break
    }
  }

  const handleReadAll = async () => {
    switch (userRole) {
      case 'user':
        await Notification.userMarkAsReadAll().then(() =>
          store.dispatch(Actions.reset('totalUnreadNotification')),
        )
        break
      case 'admin':
        await Notification.adminMarkAsReadAll().then(() =>
          store.dispatch(Actions.reset('totalUnreadNotification')),
        )
        break
    }
  }
  return (
    <>
      {isMobile && (
        <BackNavigation
          title="Notification"
          rightComponent={
            <Typography size={12} onClick={handleReadAll}>
              Mark as read all
            </Typography>
          }
        />
      )}
      {!isMobile && (
        <StyleNotificationHeader>
          <Row justifyContent="space-between">
            <Typography
              content={`You have ${totalUnreadNotification ?? 0} notification`}
              size={12}
              tc="greyText"
            />
            <Typography
              content="Mark as read all"
              size={12}
              tc="primary"
              onClick={handleReadAll}
            />
          </Row>
        </StyleNotificationHeader>
      )}

      <StyleNotificationBody id="scrollableDiv">
        {!notifications.length && (
          <Empty
            src="emptyNotification"
            title="No Notifications"
            description="Once you receive notifications, they will appear here."
          />
        )}
        {notifications.length > 0 && (
          <InfiniteScroll
            dataLength={notifications.length}
            next={() => {
              const updatedParams = {
                ...params,
                page: params.page + 1,
              }
              setParams(updatedParams)
              fetchNotifications('append', updatedParams)
            }}
            hasMore={params.page * params.limit < totalItems}
            loader={<h4>Loading...</h4>}
            scrollableTarget="scrollableDiv"
          >
            {notifications.map((item: any) => (
              <NotificationInfoCard
                key={item.id}
                item={item}
                onClick={() => onPressNotification(item)}
              />
            ))}
          </InfiniteScroll>
        )}
      </StyleNotificationBody>
    </>
  )
}

export default NotificationPage
